import React, { useState, useEffect } from "react";
import { getImage } from "gatsby-plugin-image";
import { graphql } from "gatsby";
import Seo from "../components/seo";
import SchemaMarkup from "../components/SchemaMarkup";
import MeetManager from "../components/meetManager";
import Review from "../components/review";
import CommunityHeader from "../components/communityHeader";
import Hero from "../components/hero";
import Welcome from "../components/welcome";
import Floorplans from "../components/floorplans";
import McKCares from "../components/mckCares";
import Footer from "../components/footer";
import OverlaySpecial from "../components/overlaySpecial";
import Neighborhood from "../components/neighborhood";
import Amenities from "../components/amenities";
import "../pages/mckstyles.scss";
import EmergencyAnnouncements from "../components/emergencyAnnouncements";
import Sitemap from "../components/tiny_components/sitemapImg";
import { fontColorBlue } from "../components/shared.module.scss";
import ScheduleTourRHF from "../components/scheduleTourRHF";
import ReComForYou from "../components/recComForYou";
import PreLeaseBannerWaitlistFormRHF from "../components/preLeaseBannerWaitlistFormRHF";
import { useSessionContext } from "../context/SessionContext";
import { extractCityAndState } from "../utils/helperFunctions";
import Search from "../components/search";
import useArrivalInfo from "../utils/useArrivalInfo";


const DynCommunityPageMI = ({ data }) => {
  const [visited, setVisited] = useState(true);
  const [emergencyStatus, setEmergencyStatus] = useState(true);
  const [emergencyHeight, setEmergencyHeight] = useState(0);
  const { sessionId } = useSessionContext();
  const arrivalInfo = useArrivalInfo();

  const [isMenuActive, setIsMenuActive] = useState(false); // Bringing awareness of menu visibility outside of the header

  const handleMenuStateChange = (active) => {
    setIsMenuActive(active);
  };

  const simage = data.contentfulCommunity.sitemap
    ? getImage(data.contentfulCommunity.sitemap.gatsbyImageData)
    : "";

  const handleEmergencyUpdate = (status) => {
    setEmergencyStatus(status);
  };

  useEffect(() => {
    //check if user has visited this site before
    //console.log(sessionStorage.getItem('visited:'+data.contentfulCommunity.slug));
    if (
      sessionStorage.getItem("visited:" + data.contentfulCommunity.slug) ===
      null
    ) {
      setVisited(false); //this is the first time
      sessionStorage.setItem(
        "visited:" + data.contentfulCommunity.slug,
        "true",
      ); //next time will not be the first time
    }
  }, []);

  const hoursData = data.allContentfulHours.edges ?? "";

  //console.log("hoursData", hoursData);

  // Here we filter out hours that do not apply to this community and order them by priority
  const communityHoursDataArray = hoursData
    .filter(
      ({ node }) =>
        node.community &&
        node.community.some(
          (community) => community.slug === data.contentfulCommunity.slug,
        ) &&
        node.active,
    )
    .sort((a, b) => b.node.priority - a.node.priority);

  //console.log("communityHoursDataArray", communityHoursDataArray);

  // Select the highest priority entry
  const communityHoursData =
    communityHoursDataArray.length > 0 ? communityHoursDataArray[0] : null;

  //console.log("fishes", communityHoursData);

  //console.log("emergencyStatus", emergencyStatus);

  return (
    <main>
      {emergencyStatus && (
        <EmergencyAnnouncements
          onEmergencyUpdate={handleEmergencyUpdate}
          slug={data.contentfulCommunity.slug}
          onHeightChange={setEmergencyHeight} // set the height of the component
        />
      )}
      <CommunityHeader
        cname={data.contentfulCommunity.communityName}
        phone={data.contentfulCommunity.phone}
        address={data.contentfulCommunity.address}
        slug={data.contentfulCommunity.slug}
        citySlug={data.contentfulCommunity.citySlug}
        area={data.contentfulCommunity.area}
        hours={data.contentfulCommunity.hours.hours} // We can keep hours here as a fallback
        hoursData={communityHoursData ? communityHoursData.node.hours : null} // New hours content type
        hoursLine={data.contentfulCommunity.shortHours}
        emergencyStatus={emergencyStatus}
        emergencyHeight={emergencyHeight} // will set pixel height
        onMenuStateChange={handleMenuStateChange}
        email={data.contentfulCommunity.email}
      />
      <Hero
        heroimg={data.contentfulCommunity.hero}
        heroslides={data.contentfulCommunity.heroSlides}
      />
      <br />
      <br />
      <div id="floorplans">
      <Floorplans
        slug={data.contentfulCommunity.slug}
        cid={data.contentfulCommunity.rmpropid}
        area={data.contentfulCommunity.area}
        citySlug={data.contentfulCommunity.citySlug}
        utilitiesIncluded={data.contentfulCommunity.utilitiesIncluded}
        flrplns={data.allContentfulFloorplans.edges}
        cname={data.contentfulCommunity.communityName}
        floorplanCalloutField={data.contentfulCommunity.floorplanCalloutField}
        email={data.contentfulCommunity.email}
        crossSellingFloorplans={data.contentfulCommunity.crossSellingFloorplans || []}
      />
      </div>
      <br />
      <br />
      <br />
      {/* Conditional rendering: PreLeaseBannerWaitlistFormRHF for prelease, ScheduleTourRHF for regular contact */}
      {data.contentfulCommunity?.showPreLeaseBanner ? (
        <PreLeaseBannerWaitlistFormRHF 
          cname={data.contentfulCommunity.communityName}
          slug={data.contentfulCommunity.slug}
          toEmail={data.contentfulCommunity.email}
          sessionId={sessionId}
          arrivalInfo={arrivalInfo}
        />
      ) : (
        <ScheduleTourRHF
          slug={data.contentfulCommunity.slug}
          toEmail={data.contentfulCommunity.email}
          sessionId={sessionId}
          arrivalInfo={arrivalInfo}
          //useLeads={true} // Retaining commented out prop
        />
      )}
      <br />
      <br />
      <br />
      <div id="amenities">
      <Amenities
        amenities={data.contentfulCommunity.amenities}
        textOnlyAmenities={data.contentfulCommunity.textOnlyAmenities}
        citySlug={data.contentfulCommunity.citySlug}
        area={data.contentfulCommunity.area}
        slug={data.contentfulCommunity.slug}
      />
      </div>
      <br />
      <br />
      <div className=" container" id="sitemap" >
        <div className="columns">
          <div className="column has-text-centered">
            <br />
            <br />
            <h2
              className={fontColorBlue}
              style={{
                textAlign: "center",
                fontFamily: "MoonTime",
                fontSize: "5rem",
              }}
            >
              Site Map
            </h2>
            <br />
            <Sitemap
              simage={simage}
              slug={data.contentfulCommunity.slug}
              area={data.contentfulCommunity.area}
              citySlug={data.contentfulCommunity.citySlug}
            />
          </div>
        </div>
      </div>
      <br />
      <br />
      <Welcome
        welimg={data.contentfulCommunity.welcomeHomeImage}
        address={data.contentfulCommunity.address}
        cname={data.contentfulCommunity.communityName}
      >
        {data.contentfulCommunity.welcomeHomeText.welcomeHomeText}
      </Welcome>
      <br />
      <br />
      <MeetManager
        managerName={data.contentfulCommunity.managerName}
        managerTitle={
          data.contentfulCommunity.managerTitle && 
          data.contentfulCommunity.managerTitle !== "Community Manager" 
            ? data.contentfulCommunity.managerTitle 
            : "Community Manager"
        }
        apartmentName={data.contentfulCommunity.communityName}
        managerImage={data.contentfulCommunity.managerImage}
      >
        {data.contentfulCommunity.managerQuoteLong &&
          data.contentfulCommunity.managerQuoteLong.managerQuoteLong}
      </MeetManager>
      <br />
      <br />
      <br />
      <ReComForYou data={data.contentfulCommunity.recommendedCommunities} />
      <br />
      <br />
      <Neighborhood
        favSpots={data.contentfulCommunity.favoriteSpots}
        neighborhoodText={
          data.contentfulCommunity.neighborhood
            ? data.contentfulCommunity.neighborhood.neighborhood
            : ""
        }
      />
      <br />
      <br />
      <div className=" container" id="sisters">
        <div className="columns is-padded">
          <div className="column ">
            <h1
              className={fontColorBlue}
              style={{
                textAlign: "center",
                fontFamily: "MoonTime",
                fontSize: "5rem",
              }}
            >
              Sister Communities
            </h1>
            <br />
            <hr />
            <br />
            <div className="columns">
              <div className="column ">
                <Search
                  city={data.contentfulCommunity.citySlug}
                  state={data.contentfulCommunity.area.toLowerCase()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <Review
        revTitle={data.contentfulCommunity.reviewTitle}
        revAuthor={data.contentfulCommunity.reviewAuthor}
        revImage={data.contentfulCommunity.reviewImage}
        reviews={data.contentfulCommunity.reviewsSlider}
      >
        {data.contentfulCommunity.review &&
          data.contentfulCommunity.review.review}
      </Review>
      <br />
      <br />
      <McKCares />
      <br />
      <br />
      <Footer
        cname={data.contentfulCommunity.communityName}
        phone={data.contentfulCommunity.phone}
        address={data.contentfulCommunity.address}
        slug={data.contentfulCommunity.slug}
        area={data.contentfulCommunity.area}
        citySlug={data.contentfulCommunity.citySlug}
        email={data.contentfulCommunity.email}
        isMenuActive={isMenuActive}
      />
      {!visited &&
        data.contentfulCommunity.specialPopup &&
        Object.keys(data.contentfulCommunity.specialPopup).length > 0 &&
        data.contentfulCommunity.specialPopup.specialTitle != "NONE" && (
          <OverlaySpecial
            title="Special"
            des={
              data.contentfulCommunity.specialPopup.specialDescription
                .specialDescription
            }
            date={data.contentfulCommunity.specialPopup.specialExpire}
            cid={data.contentfulCommunity.rmpropid}
          />
        )}
    </main>
  );
};

export const data = graphql`
  query ($slug: String) {
    contentfulCommunity(slug: { eq: $slug }) {
      id
      address
      area
      description
      citySlug
      phone
      email
      maxBeds
      communityName
      managerQuoteLong {
        managerQuoteLong
      }
      contactUsBanner {
        gatsbyImageData
      }
      managerName
      managerTitle
      slug
      hero {
        gatsbyImageData
      }
      welcomeHomeImage {
        gatsbyImageData
      }
      managerImage {
        gatsbyImageData
      }
      hours {
        hours
      }
      shortHours
      exactLocation {
        lat
        lon
      }
      reviewTitle
      reviewAuthor
      rmpropid
      welcomeHomeText {
        welcomeHomeText
      }
      review {
        review
      }
      gallery {
        id
        gatsbyImageData
      }
      amenities {
        id
        gatsbyImageData
        title
      }
      textOnlyAmenities
      heroSlides {
        gatsbyImageData
      }
      reviewImage {
        gatsbyImageData
      }
      neighborhood {
        neighborhood
      }
      favoriteSpots {
        gatsbyImageData
        title
        description
      }
      specialPopup {
        specialDescription {
          specialDescription
        }
        specialExpire
        specialTitle
      }
      sitemap {
        gatsbyImageData
      }
      reviewsSlider {
        review {
          review
        }
        author
        image {
          gatsbyImageData
          title
        }
        title
      }
      seoDescription {
        seoDescription
      }
      seoTitle
      recommendedCommunities {
        id
        communityName
        slug
        area
        citySlug
        description
        contactUsBanner {
          title
          gatsbyImageData
        }
        hero {
          gatsbyImageData
        }
      }
      showPreLeaseBanner
      utilitiesIncluded
      floorplanCalloutField
      crossSellingFloorplans {
        id
        communitySlug
        floorplanImages {
          gatsbyImageData
        }
        bannerImage {
          gatsbyImageData
        }
        baths
        numBaths
        beds
        floorplanName
        floorplanTitle
        floorplanSlug
        sqFt
        community {
          communityName
          slug
          area
          citySlug
          rmpropid
        }
      }
    }
    allContentfulFloorplans(filter: { communitySlug: { eq: $slug } }) {
      edges {
        node {
          communitySlug
          floorplanImages {
            gatsbyImageData
          }
          bannerImage {
            gatsbyImageData
          }
          baths
          numBaths
          beds
          sqFt
          floorplanName
          floorplanTitle
          floorplanSlug
        }
      }
    }
    allContentfulHours {
      edges {
        node {
          hoursType
          active
          priority
          hours
          community {
            communityName
            slug
          }
        }
      }
    }
  }
`;

export const Head = ({ data }) => {
  let tt;

  if (
    data.contentfulCommunity.seoTitle &&
    data.contentfulCommunity.seoTitle.length > 0
  ) {
    tt = data.contentfulCommunity.seoTitle;
  } else {
    if (data.contentfulCommunity.communityName == "Azure Winter Park") {
      tt =
        "Azure Winter Park apartments in Florida | Studio, 1 - 3 Bedroom Apts";
    } else if (data.contentfulCommunity.communityName == "Indigo Winter Park") {
      tt =
        "Indigo Winter Park apartments | 1 - 2 Bedroom Apts near Full Sail University";
    } else if (data.contentfulCommunity.communityName == "The Wesley") {
      tt =
        "The Wesley apartments in Orlando, Florida | Swimming Pool and 1 - 3 Bedroom Apts";

    } else if (data.contentfulCommunity.communityName == "Manchester West") {
      tt =
        "Manchester West apartments in the West Side of Ann Arbor, Michigan | 1 - 2 Bedroom Apts";
    } else if (
      data.contentfulCommunity.communityName == "Medical Center Court"
    ) {
      tt =
        "Medical Center Court apartments in Ann Arbor, Michigan near University of Michigan Hospital | 1 - 2 Bedroom Apts";
    } else if (data.contentfulCommunity.communityName == "Schooner Cove") {
      tt =
        "Schooner Cove apartments in Ypsilanti, Michigan on Ford Lake | 1 - 3 Bedroom Apts";
    } else if (
      data.contentfulCommunity.communityName == "State Street Village"
    ) {
      tt =
        "State Street Village apartments in Ann Arbor, Michigan | New 1 - 4 Bedroom Apts";
    } else if (data.contentfulCommunity.communityName == "The Villas") {
      tt =
        "The Villas apartments in Ypsilanti, Michigan | 1 - 2 Bedroom Apts near EMU and Washtenaw Community College";
    } else {
      let studios = ["Bellagio", "The Eusonian"];
      let beds =
        parseInt(data.contentfulCommunity.maxBeds, 10) > 1
          ? "1 - " + data.contentfulCommunity.maxBeds
          : "1";
      tt = `${data.contentfulCommunity.communityName} apartments in ${extractCityAndState(data.contentfulCommunity.address)} | ${studios.includes(data.contentfulCommunity.communityName) ? "Studio," : ""} ${beds} Bedroom Apts`;
    }
  }

  // Prepare community data for schema markup
  const communityData = {
    ...data.contentfulCommunity,
    hoursData: data.allContentfulHours?.edges?.find(
      ({ node }) =>
        node.community &&
        node.community.some(
          (community) => community.slug === data.contentfulCommunity.slug
        ) &&
        node.active
    )?.node?.hours
  };

  return (
    <>
      <Seo
        title={tt}
        description={
          data.contentfulCommunity.seoDescription
            ? data.contentfulCommunity.seoDescription.seoDescription
            : data.contentfulCommunity.description
        }
      />
      <SchemaMarkup 
        communityData={communityData}
        floorplans={data.allContentfulFloorplans?.edges}
      />
    </>
  );
};

export default DynCommunityPageMI;
